import Lang from './Lang'
import Swal from 'sweetalert2'

export default class ModuleNavigation {
    #element

    #formSelector = '#navigation_form'
    #requestedModuleSelector = '#requested_module'
    #actionSelector = '#action'
    #enabledSelector = '#navigation_enabled'

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ModuleNavigation(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#handleClick)
    }

    #handleClick = async (event) => {
        event.preventDefault()

        let action = this.#element.dataset.gpAction ?? 'next'
        let enabled = Boolean(Number(document.querySelector(this.#enabledSelector).value))

        // When the action is next (in pagination) or finish (next button) the navigation must be enabled
        if (!enabled && (action === 'next' || action === 'finish')) {
            Swal.fire({
                icon: 'info',
                title: Lang.get('gamified_video.play_first'),
                text: Lang.get('gamified_video.play_first_description'),
            })
            return
        }

        document.querySelector(this.#requestedModuleSelector).value =
            this.#element.dataset.gpRequestedModule
        document.querySelector(this.#actionSelector).value = action
        document.querySelector(this.#formSelector).submit()
    }

    static enableNavigation() {
        document.querySelector('#navigation_enabled').value = 1
    }

    static disableNavigation() {
        document.querySelector('#navigation_enabled').value = 0
    }
}
